/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import BrandLogo from '../../../../_supplier/assets/media/uProcureLogo.png'
import LoginBg from '../../../../_supplier/assets/media/login bg.png'
import BackArrow from '../../../../_supplier/assets/media/svg_supplier/back arrow.svg'
import APICallService from '../../../../api/apiCallService'
import { AUTH } from '../../../../api/apiEndPoints'
import { AuthJSON } from '../../../../api/apiJSON/auth'
import { auth } from '../../../../utils/toast'
import OtpInput from '../../../custom/otpInput/OtpInput'
import { authCardClassName } from '../AuthLayout'

const VerifyPassword = (props: any) => {
  const inputRefs: any = useRef([])
  const location: any = useLocation()
  const navigate = useNavigate()
  const [otp, setOtp] = useState([])
  const [timer, setTimer] = useState(60)
  const [resendLoading, setResendLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleChange = (value: string, index: number) => {
    let temp: any = [...otp]
    if (value) {
      index === 5 ? inputRefs.current[0].focus() : inputRefs.current[index + 1].focus()
    }
    temp[index] = value
    setOtp(temp)
  }

  const handleResend = async () => {
    if (!timer) {
      setResendLoading(true)
      let data = {}
      if (location.state.email) {
        data = {
          email: location.state.email,
        }
      } else {
        data = {
          phoneCountry: location.state.phoneCountry,
          phone: location.state.phone,
        }
      }
      let apiService = new APICallService(
        AUTH.FORGOTPASSWORD,

        AuthJSON.forgotPassword(data)
      )
      let response = await apiService.callAPI()

      if (response) {
        toast.success(auth.forgotOTPResend)
      }
      setTimer(60)
      setResendLoading(false)
    }
    // handleVerify()
  }

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    inputRefs.current[0].focus()
    if (!location.state) {
      navigate('/auth/login')
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  useEffect(() => {
    let timeLeft = timer
    if (timeLeft === 0) {
      setTimer(0)
    }
    if (!timeLeft) return
    const intervalId = setInterval(() => {
      setTimer(timeLeft - 1)
    }, 1000)
    return () => clearInterval(intervalId)
  }, [timer])

  const handleSubmit = async () => {
    setLoading(true)
    let data: any = { code: otp.join('') }
    if (location.state) {
      if (location.state.email) {
        data = {
          ...data,
          email: location.state.email,
        }
      } else {
        data = {
          ...data,
          phoneCountry: location.state.phoneCountry,
          phone: location.state.phone,
        }
      }
      let apiService = new APICallService(AUTH.VERIFYPASSWORD, AuthJSON.verifyPassword(data))
      let response = await apiService.callAPI()
      if (response) {
        toast.success(auth.verifiedOTP)
        navigate('/auth/create-password', { state: data })
      }
      setOtp([])
      // setTimer(30)
      setLoading(false)
    }
  }

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid min-vh-100 h-100'>
      <div
        className='d-flex flex-column flex-lg-row-fluid w-lg-50 bg-body px-4 py-6 sm:px-6 sm:py-8 lg:p-25 order-2 overflow-auto min-h-0'
        style={{
          backgroundImage: `url(${LoginBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div
          className='d-flex w-100 justify-content-center justify-content-lg-end align-items-center flex-lg-row-fluid py-2 sm:py-4 lg:py-0'
          style={{ paddingRight: '86px' }}
        >
          <form className={clsx(authCardClassName, 'd-flex flex-column')} action='#'>
            <div className='mb-4 sm:mb-6 flex-grow-1'>
            <div
                className='mb-3 mx-auto'
                style={{
                  display: 'flex',
                  width: '72px',
                  height: '72px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '9px',
                  borderRadius: '99px',
                  background: 'var(--white, #FFF)',
                }}
              >
                <span role='img' aria-label='lock' className='text-[32px]'>
                📬
                </span>
              </div>
              <h1 className='text-dark text-center fw-700 mb-3 text-[22px] sm:text-[28px] lg:text-[28px] gap-6'>
                Check your email 
              </h1>
              <p className='text-center fw-normal text-sm sm:text-base px-1 sm:px-0 mt-5 gap-6'>
                We&apos;ve sent an OTP to{' '}
                {location.state
                  ? location.state.email
                    ? location.state.email
                    : location.state.phone
                      ? location.state.phoneCountry + ' ' + location.state.phone
                      : ''
                  : ''}
                <br />
                Enter Verification Code
              </p>
              <div className='d-flex flex-wrap mb-2 justify-content-center mt-4 sm:mt-5'>
                <div className='d-flex flex-wrap'>
                  <OtpInput
                    value={otp}
                    valueLength={6}
                    onChange={(value: string, index: number) => {
                      handleChange(value, index)
                    }}
                    inputRefs={inputRefs}
                  />
                </div>
              </div>
              <div className='flex flex-col items-center w-full mx-auto mb-4 sm:mb-5 mt-4 sm:mt-5 gap-6'>
                <button
                  type='button'
                  className={clsx('form-control form-control-custom text-center border-0')}
                  style={{
                    display: 'flex',
                    width: '416px',
                    height: '56px',
                    padding: '10px 20px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    background: '#1B74E4',
                    borderRadius: '12px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#fff',
                    opacity: otp.length <= 5 || loading ? 0.5 : 1,
                    cursor: otp.length <= 5 || loading ? 'not-allowed' : 'pointer',
                  }}
                  onClick={handleSubmit}
                  disabled={otp.length <= 5 || loading}
                >
                  {loading ? (
                    <span className='indicator-progress indicator-label fs-16 fw-600'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <span className='indicator-label fs-16 fw-bolder'>Verify OTP</span>
                  )}
                </button>
              </div>
              <div className='fs-14 fw-400 text-center d-flex justify-content-center'>
                {resendLoading ? (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...
                  </span>
                ) : (
                  <p
                    className='fs-14 fw-400 me-2'
                    style={timer ? {} : { cursor: 'pointer' }}
                    onClick={handleResend}
                  >
                    Didn't receive the code? Resend the code
                  </p>
                )}
                <span className='fs-14 fw-400'>
                  {timer ? (timer < 10 ? ' in 00:0' + timer : ' in 00:' + timer) : ''}
                </span>
              </div>
            </div>

            <div className='d-flex justify-content-center' style={{ padding: '40px' }}>
              <Link
                to='/auth/login'
                className='text-[#1B74E4] font-bold text-sm sm:text-[16px]'
                style={{
                  display: 'flex',
                  width: '416px',
                  height: '56px',
                  padding: '16px 22px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '8px',
                  borderRadius: '12px',
                  border: '1px solid var(--brand-primary-blue, #1B74E4)',
                  background: 'var(--white, #FFF)',
                }}
              >
                <img src={BackArrow} alt='' width={18} height={18} />
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
export default VerifyPassword
